import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';

class CoolLoadingButtonComponent {
    constructor(_changeDetector) {
        this._changeDetector = _changeDetector;
        this.loadingChanged = new EventEmitter();
        this.loadingFinished = new EventEmitter();
        this.innerClass = '';
    }
    onClick() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.disabled || this.isLoading || !this.clickHandler) {
                return;
            }
            try {
                this._changeIsLoading(true);
                yield Promise.resolve(this.clickHandler(this.clickParameters));
            }
            finally {
                this._changeIsLoading(false);
                this.loadingFinished.next();
            }
        });
    }
    _changeIsLoading(loadingValue) {
        this.isLoading = loadingValue;
        this.loadingChanged.next(this.isLoading);
        this._changeDetector.markForCheck();
    }
}
CoolLoadingButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: CoolLoadingButtonComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
CoolLoadingButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.1.1", type: CoolLoadingButtonComponent, selector: "cool-loading-button", inputs: { color: "color", spinnerColor: "spinnerColor", disabled: "disabled", clickHandler: "clickHandler", clickParameters: "clickParameters", innerClass: ["class", "innerClass"] }, outputs: { loadingChanged: "loadingChanged", loadingFinished: "loadingFinished" }, ngImport: i0, template: "<button mat-raised-button\n        [color]=\"color\"\n        [disabled]=\"disabled || isLoading\"\n        class=\"{{ innerClass }}\"\n        (click)=\"onClick()\">\n  <mat-spinner *ngIf=\"isLoading\" [color]=\"spinnerColor\" [diameter]=\"20\" class=\"spinner\"></mat-spinner>\n\n  <ng-content></ng-content>\n</button>\n", styles: [".spinner{display:inline-block;margin-right:.5rem}\n"], components: [{ type: i1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i2.MatSpinner, selector: "mat-spinner", inputs: ["color"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: CoolLoadingButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cool-loading-button', changeDetection: ChangeDetectionStrategy.OnPush, template: "<button mat-raised-button\n        [color]=\"color\"\n        [disabled]=\"disabled || isLoading\"\n        class=\"{{ innerClass }}\"\n        (click)=\"onClick()\">\n  <mat-spinner *ngIf=\"isLoading\" [color]=\"spinnerColor\" [diameter]=\"20\" class=\"spinner\"></mat-spinner>\n\n  <ng-content></ng-content>\n</button>\n", styles: [".spinner{display:inline-block;margin-right:.5rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { color: [{
                type: Input
            }], spinnerColor: [{
                type: Input
            }], disabled: [{
                type: Input
            }], clickHandler: [{
                type: Input
            }], clickParameters: [{
                type: Input
            }], loadingChanged: [{
                type: Output
            }], loadingFinished: [{
                type: Output
            }], innerClass: [{
                type: Input,
                args: ['class']
            }] } });

class CoolLoadingButtonModule {
}
CoolLoadingButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: CoolLoadingButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CoolLoadingButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: CoolLoadingButtonModule, declarations: [CoolLoadingButtonComponent], imports: [CommonModule,
        MatButtonModule,
        MatProgressSpinnerModule], exports: [CoolLoadingButtonComponent] });
CoolLoadingButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: CoolLoadingButtonModule, providers: [], imports: [[
            CommonModule,
            MatButtonModule,
            MatProgressSpinnerModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.1", ngImport: i0, type: CoolLoadingButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatButtonModule,
                        MatProgressSpinnerModule,
                    ],
                    providers: [],
                    declarations: [
                        CoolLoadingButtonComponent,
                    ],
                    exports: [
                        CoolLoadingButtonComponent,
                    ],
                }]
        }] });

/*
 * Public API Surface of loading-button
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CoolLoadingButtonComponent, CoolLoadingButtonModule };
